import { mdiViewDashboard } from "@mdi/js";
import settingsReducer from "./reducer";
import Dashboard from "./views/Dashboard";
import Settings from "./views/Settings";
const dashlets = [];
function registerDashlet(title, width, height, position, component, isVisible, props, options) {
    const fixed = options !== undefined ? options.fixed || false : false;
    const closable = options !== undefined ? options.closable : true;
    dashlets.push({
        title,
        position,
        width,
        height,
        component,
        isVisible,
        props,
        fixed,
        closable,
    });
}
function init(context) {
    context.registerReducer(["settings", "interface"], settingsReducer);
    context.registerMainPage("dashboard", "Dashboard", Dashboard, {
        priority: 1,
        hotkey: "1",
        group: "dashboard",
        props: () => ({ dashlets }),
        mdi: mdiViewDashboard,
    });
    context.registerSettings("Interface", Settings, () => ({ dashlets }), undefined, 1000);
    context.registerDashlet = registerDashlet;
    return true;
}
export default init;
